import commonReducers from "./common";
import widgetResucers from "./widget";
import flowReducers from "./flow";

export default Object.assign({}, commonReducers, flowReducers, widgetResucers);
